import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IDinningDetailsData } from "../../types/api/dinningApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";

const DinningDetails: React.FC<{ dinning_details: IDinningDetailsData }> = ({ dinning_details }) => {
    const {t} = useTranslation()
const timming_json = t('dinning.dinning.timming', { returnObjects: true })  as string[];
const dress_code_json = t('dinning.dinning.dress_code', { returnObjects: true })  as string[];

console.log(timming_json,'timming_json');

    return (
        <div>
            <div>
                <section className="restaurant-section">
                    <div className="container">
                        <Row className="row align-items-center">
                            <Col md={6}>
                                <div className="restaurant-img">
                                    <img src={dinning_details.image} alt="img" className="img-fluid" />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="restaurant-details">
                                    <h3 className="title">{t('dinning.dinning.name')}</h3>
                                    <p className="text">{t('dinning.dinning.desription')}</p>
                                    <div className="details-list">
                                        <h4 className="title">{t('dinning.dinning.restaurant_timing')}</h4>
                                        <ul>
                                            {
                                                timming_json && timming_json.length ?
                                                    timming_json.map((timeData: string, index: number) => (
                                                        <li key={'Dining_Timing_' + index}>{timeData}</li>
                                                    ))
                                                    : <NoData message="Oops, No Dinning Timing Details Found!!" />
                                            }
                                        </ul>
                                    </div>
                                    <div className="details-list">
                                        <h4 className="title">{t('dinning.dinning.dress_code_title')}</h4>
                                        <ul>
                                            {
                                                dress_code_json && dress_code_json.length ?
                                                    dress_code_json.map((dc: string, index: number) => (
                                                        <li key={'Dining_Timing_' + index}>{dc}</li>
                                                    ))
                                                    : <NoData message="Oops, No Dinning Timing Details Found!!" />
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default DinningDetails;